import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { DashboardFournisseurState } from './state';
import { DASHBOARD_FOURNISSEUR } from './mutation-types';
import FactureService from '@/modules/DashboardFournisseur/services/StatsFactureService';
import {
    DashboardFournisseurActions,
    DashboardFournisseurActionType
} from '@/modules/DashboardFournisseur/store/action-types';
import ReglementService, {
    FilterReglementFournisseur
} from '@/modules/ReglementsFournisseurs/services/ReglementService';
import { SortType, sortValue } from '@/models/SortType';


export const actions: ActionTree<DashboardFournisseurState, RootState> = {

    async [DashboardFournisseurActions.GET_STATS]({ commit }: DashboardFournisseurActionType): Promise<void> {
        FactureService.getStatsFacturesFournisseur()
            .then(async (response: any) => {
                if (response !== undefined || response?.status !== undefined) {
                    if (response.status !== 200) {
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    commit(DASHBOARD_FOURNISSEUR.SET_STATS, response.data);
                } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            }).catch(async error => {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },

    async [DashboardFournisseurActions.GET_CINQ_DERNIERS_REGLEMENTS]({ commit }: DashboardFournisseurActionType): Promise<void> {
        const payload: FilterReglementFournisseur = {
            size: 5,
            sort: sortValue('date_reglement', SortType.DESC)
        };
        ReglementService.getReglements(payload)
            .then(async (response: any) => {
                if (response !== undefined || response?.status !== undefined) {
                    if (response.status !== 200) {
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    commit(DASHBOARD_FOURNISSEUR.SET_DERNIERS_REGLEMENTS, response.data.content);
                } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            }).catch(async error => {
            commit(
                `errorToaster/${ERROR.SET_MESSAGE}`,
                await ErrorManager.processError(error),
                { root: true }
            );
        });
    },
};
